module.exports = __webpack_public_path__ + "static/media/sombra-deck-cards.a6287469.svg";